export default "__VITE_ASSET__3kHIy0Vq__"